/* Author: Vinod
Date: 27/01/2020
Issue NO: PL_2525
Description: The settings are saved in DB but not reflecting in UI.
*/

import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';
var axios_instance = get_axios_instance(api_variables.SERVICE_PROBATION_SETTINGS);

const _pk_name = 'id';

const state = {
    data: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: {}
};

const getters = {
    editMode: (state) => {
        return state.editMode;
    },
    record: (state) => {
        return state.record;
    }
};

const mutations = {
    set: (state, payload) => {
        state.data = payload;
    },

    addProbationPeriod: (state, payload) => {
        if (payload) {
            state.data[payload.le_id] = payload; // PL_2525
        }
    },

    updateProbationPeriodById: (state, payload) => {
        state.data[payload.le_id] = payload; // PL_2525
    },

    removeProbationPeriodById: (state, [payload, id]) => {
        for (let i = 0; i < state.data[id].length; i++) {
            if (state.data[id][i][_pk_name] == payload) {
                state.data[id].splice(i, 1);
            }
        }
        if (state.data[id].length == 0) state.data = {};
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
    setEditMode: (state, payload) => {
        state.editMode = payload.editMode;
        state.record = payload.record;
    }
};

const actions = {
    async fetchAll({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance.get(`/`, {
                params: {
                    le_id: payload
                }
            });
            commit('setFetching', false);
            if (res.status == 200) {
                commit('set', res.data.payload.data);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async create({ commit }, payload) {
        try {
            commit('setSaving', true);
            let res = await axios_instance.post('/', payload);
            commit('setSaving', false);
            if (res.data.status) {
                //commit('addProbationPeriod', res.data.payload.data); // PL_2525
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async update({ commit }, payload) {
        try {
            commit('setSaving', true);
            let res = await axios_instance.put(`/${payload.data.id}`, payload); // PL_2525
            commit('setSaving', false);
            if (res.data.status) {
                commit('updateProbationPeriodById', res.data.payload); // PL_2525
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async delete({ commit }, [payload, id]) {
        try {
            commit('setDeleting', true);
            let res = await axios_instance.delete(`/${payload.id}`);
            commit('setDeleting', false);
            if (res.status == 200) {
                commit('removeProbationPeriodById', [payload.id, id]);
            }
        } catch (err) {
            throw errorHandler(err.response);
        }
    },
    async changeEditMode({ commit }, payload) {
        try {
            commit('setEditMode', payload);
        } catch (err) {
            throw errorHandler(err.response);
        }
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};